import SimpleSearch from "./SimpleSearch";

const Search = () => {
    return <SimpleSearch />;
};

export default Search;
